// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"EditShippingRuleAction_closeButton__2djdt","miniForm":"EditShippingRuleAction_miniForm__kb636","formItem":"EditShippingRuleAction_formItem__1iQHM"};